export default __webpack_public_path__ + "static/media/ParisToBarcelona.e3e81aac.webp";